import { render, staticRenderFns } from "./farmanova.vue?vue&type=template&id=0f22e298&"
import script from "./farmanova.vue?vue&type=script&lang=js&"
export * from "./farmanova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports